import React from 'react';
import { CheckCircle2, Zap, Shield, HeartHandshake, Code2, Clock } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <Zap className="w-6 h-6" />,
      title: 'Affordable Pricing',
      description: 'Premium quality at budget-friendly rates. No hidden costs, transparent pricing.'
    },
    {
      icon: <Code2 className="w-6 h-6" />,
      title: 'Clean & Scalable Code',
      description: 'Well-architected, maintainable code that grows with your business needs.'
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: 'Modern UI',
      description: 'Beautiful, responsive interfaces that work flawlessly across all devices.'
    },
    {
      icon: <Clock className="w-6 h-6" />,
      title: 'Fast Delivery',
      description: 'Efficient development process ensuring your project launches on schedule.'
    },
    {
      icon: <HeartHandshake className="w-6 h-6" />,
      title: 'Responsive Support',
      description: 'Dedicated communication and support throughout your project journey.'
    },
    {
      icon: <CheckCircle2 className="w-6 h-6" />,
      title: 'Proven Track Record',
      description: 'Successfully delivered 50+ projects with 98% client satisfaction rate.'
    }
  ];

  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Why Choose <span className="text-blue-600">Us</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            We combine technical expertise with a client-first approach to deliver exceptional results
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group relative p-8 bg-white rounded-2xl hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:border-blue-200"
            >
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-t-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
              
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 group-hover:scale-110">
                {reason.icon}
              </div>
              
              <h3 className="text-xl font-semibold text-slate-900 mb-3">{reason.title}</h3>
              <p className="text-slate-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;